import { motion } from "framer-motion";

export const WhyChooseUs = (props: any) => {
  const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <section className="relative w-full py-20 sm:py-24 bg-gray-50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">

        {/* Heading */}
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeUp}
          transition={{ duration: 0.6 }}
          className="max-w-3xl"
        >
          <p className="text-[#A60000] tracking-widest font-semibold uppercase text-sm mb-2">
            {props.subTitle}
          </p>

          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900">
            {props.title}
          </h2>

          <p className="text-gray-600 mt-4 text-base sm:text-lg leading-relaxed">
            {props.description}
          </p>
        </motion.div>

        {/* FEATURES GRID */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-14">
          {props.featureList.map((item: any, index: number) => (
            <motion.div
              key={index}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={fadeUp}
              transition={{ delay: index * 0.08, duration: 0.5 }}
              className="
                bg-white border border-gray-200 rounded-xl
                p-8 text-center
                transition-all duration-300
                hover:shadow-lg hover:-translate-y-1
              "
            >
              {/* Icon */}
              <div className="flex justify-center mb-5 text-[#A60000] text-4xl">
                {item.icon}
              </div>

              {/* Title */}
              <p className="font-semibold text-gray-900 text-lg">
                {item.title}
              </p>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
};
